/*
 * @Description: 用户模块
 * @Author: ywl
 * @Date: 2021-03-05 14:27:42
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-08-27 17:38:56
 */
import http from '@/plugin/axios';
// import { Apis } from '../index';
import { getSubName } from '@/utils/getHost';
export default {
  /**
   * 登录
   */
  login: (data: any): Promise<any> => {
    return http.post('activity/user/login', data);
  },
  /**
   * 注册
   */
  register: (data: any): Promise<any> => {
    return http.post('activity/user/register', data);
  },
  /**
   * 用户信息
   */
  getUserInfo: (): Promise<any> => {
    return http.post('activity/user/info');
  },
  /**
   * 获取验证码
   */
  getVerifyCode: (data: any): Promise<any> => {
    if (getSubName() == 'longyixiu') {
      data.appletSource = 1;
    } else if (getSubName() == 'wenjuanjia') {
      data.appletSource = 7;
    }
    return http.post('activity/user/sendSms', data);
  },
  /**
   * 找回密码
   */
  resetPassword: (data: any): Promise<any> => {
    return http.post('activity/user/resetPwd', data);
  },
  /**
   * 获取公众号二维码
   */
  // 龙艺秀
  getQRCode: (): Promise<any> => {
    if (getSubName() === 'longyixiu') {
      return http.post('activity/user/showLoginQr');
    } else {
      return http.post('activity/user/showLoginQr7');
    }
  },
  /**
   * 轮询登录二维码状态
   */
  getWxLoginStatus: (data: any): Promise<any> => {
    if (getSubName() === 'longyixiu') {
      return http.post('activity/user/checkCode', data);
    } else {
      return http.post('activity/user/checkCode7', data);
    }
  },
  /**
   * 绑定公众号用户
   */
  getBindingLogin: (data: any): Promise<any> => {
    return http.post('activity/user/loginByQr', data);
  },
  /**
   * 修改密码
   */
  changePassword: (data: any): Promise<any> => {
    return http.post('activity/user/changePassword', data);
  },
  /**
   * 修改用户名
   */
  upDateUserName: (data: any): Promise<any> => {
    return http.post('activity/user/upDateUserName', data);
  },
  /**
   * 绑定公众号openid
   */
  bindingUser: (data: any): Promise<any> => {
    if (getSubName() === 'longyixiu') {
      return http.post('activity/user/bindingUser', data);
    } else {
      return http.post('activity/user/bindingUser7', data);
    }
  },
  /**
   * 上传视频
   */
  uploadVideo: (data: any): Promise<any> => {
    return http.post('upload/video', data);
  },
  /**
   * 上传音频
   */
  uploadAudio: (data: any): Promise<any> => {
    return http.post('upload/audio', data);
  },
  /**
   * 关闭新手指引
   */
  getInfoIntro: (data: any): Promise<any> => {
    return http.post('activity/user/getInfoIntro', data);
  },
  /**
   * 企业微信第三方登录信息
   */
  getLoginInfo: (data: any): Promise<any> => {
    let api = '/activity/user/getLoginInfo';
    if (getSubName() == 'longyixiu') {
      data.appletSource = 1;
      api = '/activity/user/getLoginInfo';
    } else if (getSubName() == 'wenjuanjia') {
      data.appletSource = 7;
      api = '/activity/user/getLoginInfo7';
    }
    return http.post(api, data);
  },
  /**
   * qq授权登录
   */
  getQQLogin: (data: any): Promise<any> => {
    if (getSubName() == 'longyixiu') {
      data.appletSource = 1;
    } else if (getSubName() == 'wenjuanjia') {
      data.appletSource = 7;
    }
    return http.post('/activity/user/getQQLogin', data);
  },
  /**
   * pc-第三方平台获取预授权码
   */
  getPreAuthCode: (data: any): Promise<any> => {
    if (getSubName() == 'longyixiu') {
      data.appletSource = 1;
    } else if (getSubName() == 'wenjuanjia') {
      data.appletSource = 7;
    }
    return http.post('/activity/component/getPreAuthCode', data);
  },
  /**
   * pc-保存公众号授权信息
   */
  getAuthorizerInfo: (data: any): Promise<any> => {
    if (getSubName() == 'longyixiu') {
      data.appletSource = 1;
    } else if (getSubName() == 'wenjuanjia') {
      data.appletSource = 7;
    }
    return http.post('/activity/component/getAuthorizerInfo', data);
  },
  /**
   * pc-查看公众号授权信息
   */
  getAuthInfoList: (data: any): Promise<any> => {
    if (getSubName() == 'longyixiu') {
      data.appletSource = 1;
    } else if (getSubName() == 'wenjuanjia') {
      data.appletSource = 7;
    }
    return http.post('/activity/component/getAuthInfoList', data);
  },
  /**
   * pc-删除公众号授权信息
   */
  delAuthInfo: (data: any): Promise<any> => {
    return http.post('/activity/component/delAuthInfo', data);
  },
  /**
   * pc-查看授权公众号支付信息
   */
  getAuthPay: (data: any): Promise<any> => {
    return http.post('/activity/component/getAuthPay', data);
  },
  /**
   * pc-更新授权公众号支付信息
   */
  upDateAuthPay: (data: any): Promise<any> => {
    if (getSubName() == 'longyixiu') {
      data.appletSource = 1;
    } else if (getSubName() == 'wenjuanjia') {
      data.appletSource = 7;
    }
    return http.post('/activity/component/upDateAuthPay', data);
  },
  /**
   * 用户交易记录
   */
  getUserTransactionList: (data: any): Promise<any> => {
    return http.post('/recharge/getUserTransactionList', data);
  },
  /**
   * 余额购买短信
   */
  getBalancePay: (data: any): Promise<any> => {
    return http.post('/active/pay/getBalancePay', data);
  },
  /**
   * 余额消费记录
   */
  getTransactionAmount: (data: any): Promise<any> => {
    return http.post('/recharge/getTransactionAmount', data);
  },
  /**
   * 用户xx币
   */
  getUserCoin: (data: any): Promise<any> => {
    return http.post('activity/user/getUserCoin', data);
  },
  /**
   * 绑定手机号
   */
  bindingPhone: (data: any): Promise<any> => {
    return http.post('/activity/user/bindingPhone', data);
  },
  /**
   * 修改用户信息
   */
  updateHeadInfo: (data: any): Promise<any> => {
    return http.post('/activity/user/updateHeadInfo', data);
  },
  /**
   * 修改短信自定义签名
   */
  updateUserSmsSign: (data: any): Promise<any> => {
    return http.post('/activity/user/updateUserSmsSign', data);
  },
  // 通过code获取小程序链接
  getAppletUrl: (data: any): Promise<any> => {
    return http.post('/activity/question/T2/getAppletUrl', data);
  },
  /**
   * 更新用户AI币
   */
  updateAiCoin: (data: any): Promise<any> => {
    return http.post('/activity/user/updateAiCoin', data);
  },
  /**
   * 余额购买ai币
   */
  getBalancePayAiCoin: (data: any): Promise<any> => {
    return http.post('/active/pay/getBalancePayAiCoin', data);
  },
};
